const TabPanel = ({ children, value = 0, index = 0 }) => {
  return <>{value === index && children}</>;
};

export default TabPanel;
